<svg xmlns="http://www.w3.org/2000/svg" width="19" height="9" viewBox="0 0 19 9">
    <g fill="none" fill-rule="evenodd">
        <g stroke="#B8B8B8" strokeWidth="1.26">
            <g>
                <path d="M0 3.285L17.759 3.285M14.411 0L17.759 3.348 14.411 6.695" transform="translate(-650 -1362) rotate(-180 334.5 685)"/>
            </g>
        </g>
    </g>
</svg>
